import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  invisibleWrapper: {
    top: '0px',
    width: '215px',
  },
  message: {
    background: '#fff',
    borderRadius: '6px',
    WebkitBoxShadow: '0 0 2px rgba(0,0,0,0.38),0 1px 3px rgba(0,0,0,0.32)',
    boxShadow: '0 0 2px rgba(0,0,0,0.38),0 1px 3px rgba(0,0,0,0.32)',
    color: '#000',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '150%',
    padding: '8px 14px',
    textAlign: 'left',
    maxWidth: '215px',
    display: 'inline-block',
    float: 'left',
  },
  suggestionTooltipMessage: {
    boxShadow: 'none',
    background: '#E2780D',
    color: '#fff',
    fontSize: '14px',
    WebkitBoxShadow: 'none',
  },
  text: {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
  },
};

export default function Tooltip(props, context) {
  let wrapperClassName = 'Tooltip_wrapper';
  let messageClassName = 'Tooltip_message';
  if (props.isSuggestionTooltip) {
    messageClassName = 'Tooltip_suggestionMessage';
  }
  if (context.userAgent.isMobile) {
    wrapperClassName = 'Tooltip_mobileWrapper';
    messageClassName = 'Tooltip_mobileMessage';
  }

  const wrapperStyles = { ...styles.invisibleWrapper, ...props.customWrapperStyles };

  const messageStyles = props.isSuggestionTooltip
    ? { ...styles.message, ...styles.suggestionTooltipMessage }
    : styles.message;

  return (
    <div className={wrapperClassName} data-test-id="tooltip" style={wrapperStyles}>
      <div className={messageClassName} style={messageStyles}>
        {/* eslint-disable react/no-danger */}
        {props.children ? (
          <span style={styles.text}>{props.children}</span>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: props.message }} style={styles.text} />
        )}
        {/* eslint-enable react/no-danger */}
      </div>
      <div />
    </div>
  );
}

Tooltip.propTypes = {
  message: PropTypes.string,
  customWrapperStyles: PropTypes.shape({}),
  isSuggestionTooltip: PropTypes.bool,
  children: PropTypes.element,
};

Tooltip.contextTypes = {
  message: PropTypes.string,
  userAgent: PropTypes.shape({
    isMobile: PropTypes.bool.isRequired,
  }).isRequired,
};
